<h1 class="h3 mb-2 text-gray-800">Doctores</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Lista de Doctores</h6>
    </div>
    <div class="card-body">
        <div *ngIf="doctores.length==0">
            Necesita insertar un doctor
        </div>
        <div *ngIf="doctores.length > 0" class="table-responsive">
            <table [dtOptions]="dtOptions" datatable  class="row-border hover">
                <thead>
                    <tr>
                        <th>N&ordm;</th>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>E-mail</th>
                        <th>Teléfono</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let doctor of doctores; let i = index;">
                        <td>{{i+1}}</td>
                        <td>{{doctor.codigo}}</td>
                        <td>{{doctor.user.name}}</td>
                        <td>{{doctor.user.email}}</td>
                        <td>{{doctor.telefono}}</td>
                        <td><a [routerLink]="[ '/doctores/', doctor.id ]" class="btn btn-primary">Editar</a></td>
                        <td><a [routerLink]="[ '/doctores/'+doctor.id+'/casos' ]" class="btn btn-primary">Ver casos</a>
                        </td>
                        <td><button class="btn btn-danger" (click)="eliminarDoctor(doctor.id)">Eliminar</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>